import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';
import { AppStatus } from './types';

export const infraLoaders = getLoaders({
  appStatus: {
    load: async ({ version }: { version: string }): Promise<AppStatus> => {
      return executeApiCall({
        path: '/status',
        method: 'get',
        auth: false,
        payload: {
          version,
        },
      });
    },
  },
});
